import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useHead } from "@unhead/vue";
  import Navbar from "@/components/navigation/Navbar.vue";
  import ContactDetails from "@/components/ContactDetails.vue";

  import router from "./router";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

  useHead({
    titleTemplate: (titleChunk) => {
      return titleFormat(titleChunk);
    },
    // TODO: update meta data
    // meta: [
    //   { name: "description", content: "" },
    //   { name: "keywords", content: "", key: "keywords-tag" },
    //   { name: "robots", content: " ", key: "robots-tag" }
    // ],
  })

  function titleFormat (titleChunk: any) {
    const prependString = router.currentRoute.value.path == "/" ? "" : " | Sabelo's Electrical & Technologies";
    return titleChunk ? titleChunk + prependString : "Sabelo's Electrical & Technologies";
  }

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Navbar, { class: "shadow-sm" }),
    _createElementVNode("main", null, [
      _createVNode(_component_router_view)
    ]),
    _createVNode(ContactDetails)
  ], 64))
}
}

})